import React from 'react';
import PropTypes from 'prop-types';
import { Headline3 } from '@cdm/quickenloans-library/lib';
import * as Classes from './ArticleMultipleChoiseCTA.module.scss';
import { testAttributes, widgetsData } from '../../Constants';
import WidgetContainer from './widget/widget';

const ArticleMultipleChoiceCTA = ({
    className = '',
    title = 'What Are You Looking To Accomplish Today?',
    data = widgetsData,
    articleId = null,
}) => 
{
    return (
        <div
            className={`${Classes.articleMultipleChoiceCTA} ${className}`}
            data-testid={testAttributes.MULTIPLE_CTA_CONTAINER}
        >
            {title && <Headline3
                className={Classes.mainHeader}
                testId={testAttributes.MULTIPLE_CTA_HEAD_CONTAINER}
            >
                {title}
            </Headline3>}
            <WidgetContainer data={data} articleId={articleId} />
        </div>
    );
};
export default ArticleMultipleChoiceCTA;

ArticleMultipleChoiceCTA.propTypes = {
    /** CSS classes */
    className: PropTypes.string,
    /** Title of the article multiple choice CTA */
    title: PropTypes.string,
    /** Article Identifier */
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            subtitle: PropTypes.string.isRequired,
            ctaButtonText: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        })
    ),
    /** Article Identifier */
    articleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
